import React, { useEffect, useState } from "react";
import Style from "../style/footer.module.scss";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { fetchStates } from "../redux/Slice";
import { getStatesFromDB, syncStatesWithDB } from "../indexDb/stateDb";

const trendingItems = [
  "Insurance Agents-United India",
  "Tutorials For CSIR Net Life Science",
  "Football Dealers",
  "Tour Packages For Thailand",
  "Courier Services For Ahmedabad",
  "Guest House",
  "Government Hostels",
  "Hostels",
  "Hostels For Men",
  "Hostels For Women",
  "Hostels For Working Men",
  "Hostels For Working Women",
  "Hotels (Rs 500 & Below)",
  "Resorts",
  "Dormitory Services",
  "Home Stay",
  "Hostel For Girl Students",
  "3 Star Hotels",
  "5 Star Hotels",
  "2 Star Hotels",
  "4 Star Hotels",
  "Villas",
];

const collectionItems = [
  "Travel & Tourism",
  "Beauty & Fashion",
  "Health & Fitness",
  "Food & Beverage",
  "Finance",
  "On demand Services",
  "Home & Living",
  "Education & Career",
  "Recreation",
  "Jd Business Guide",
];

const businessItems = [
  { label: "Add Your Business", link: "/dashboard/new" },
  { label: "Advertise with us", link: "/advertise" },
  { label: "Free Listing", link: "/free-listing" },
  { label: "Find a Business", link: "/" },
  { label: "Blog", link: "/blog" },
  { label: "Question", link: "/question" },
];

const verticalItems = [
  { label: "How to Get Started", link: "/how-to-get-started" },
  { label: "Dashboard", link: "/dashboard" },
  { label: "Site Map", link: "/sitemap" },
  { label: "Marketing Solutions", link: "/marketing-solutions" },
  {
    label: "AI Business Listing",
    link: "using-ai-to-optimize-your-business-listing",
  },
  { label: "UnAnswered", link: "/question/unanswered" },
];

const quickLinks = [
  { label: "Browse Category", link: "/category" },
  { label: "Search Business", link: "/" },
  { label: "Faq", link: "/faq" },
  { label: "Login", link: "/login" },
  { label: "Register", link: "/register" },
  { label: "LeaderBoard", link: "/leaderboard" },
];

const socialIcons = [
  {
    src: "https://akam.cdn.jdmagicbox.com/images/icontent/newwap/web2022/flw_facebook_active.svg",
    alt: "Facebook",
  },
  {
    src: "https://akam.cdn.jdmagicbox.com/images/icontent/newwap/web2022/flw_youtube_active.svg",
    alt: "YouTube",
  },
  {
    src: "https://akam.cdn.jdmagicbox.com/images/icontent/newwap/web2022/flw_insta_active.svg",
    alt: "Instagram",
  },
  {
    src: "https://akam.cdn.jdmagicbox.com/images/icontent/newwap/web2022/flw_linkedIn_active.svg",
    alt: "LinkedIn",
  },
  {
    src: "https://akam.cdn.jdmagicbox.com/images/icontent/newwap/web2022/flw_twitter_active.svg?v=1.0",
    alt: "Twitter",
  },
];

const appIcons = [
  {
    src: "https://akam.cdn.jdmagicbox.com/images/icontent/newwap/web2022/getapp_googleplay.png?w=128&q=75",
    alt: "Google Play",
  },
  {
    src: "https://akam.cdn.jdmagicbox.com/images/icontent/newwap/web2022/getapp_appstore.png?w=128&q=75",
    alt: "App Store",
  },
];

const Footer = () => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useAppDispatch();
  const data = useAppSelector((state) => state.detail);

  useEffect(() => {
    const loadInitialData = async () => {
      const cachedStates = await getStatesFromDB();
      if (cachedStates.length > 0) {
        dispatch({ type: "detail/setData", payload: cachedStates });
      }
      setIsLoading(false);
    };
    loadInitialData();
  }, [dispatch]);

  useEffect(() => {
    const fetchAndUpdateData = async () => {
      try {
        const apiResponse = await dispatch(fetchStates()).unwrap();
        const syncedStates = await syncStatesWithDB(apiResponse);
        dispatch({ type: "detail/setData", payload: syncedStates });
      } catch (error) {
        console.error("Error fetching states");
      }
    };
    fetchAndUpdateData();
  }, [dispatch]);

  return (
    <div className={Style.footer}>
      <div className={Style.wrapper}>
        <div className={Style.trending}>
          <h2>Trending Searches</h2>
          <ul>
            {trendingItems.map((item, index) => (
              <li key={index}>
                <a href="#/">{item}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className={Style.collection}>
          <h2>Explore Collections</h2>
          <ul>
            {collectionItems.map((item, index) => (
              <li key={index}>
                <a href="#/">{item}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className={Style.city}>
          <h2>Popular Cities</h2>
          <ul>
            {isLoading ? (
              <p>Loading...</p>
            ) : (
              data.stateData?.states &&
              data.stateData.states
                .slice(0, 20)
                .flatMap((state) => state.cities || [])
                .slice(-50)
                .map((city) => (
                  <li key={city.id}>
                    <a
                      href={`/listing/city/${city.name
                        .toLowerCase()
                        .replaceAll(" ", "-")}`}
                    >
                      {city.name}
                    </a>
                  </li>
                ))
            )}
          </ul>
        </div>

        <div className={Style.Link}>
          {[
            { title: "Business", items: businessItems },
            { title: "Bipho Verticals", items: verticalItems },
            { title: "Quick Link", items: quickLinks },
          ].map((section, index) => (
            <div className={Style.linkItem} key={index}>
              <h2>{section.title}</h2>
              <ul>
                {section.items.map((item, i) => (
                  <li key={i}>
                    <a href={item.link}>{item.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className={Style.SocialSite}>
        <div className={Style.socialwrapper}>
          <div className={Style.siteIcon}>
            <h2>Follow us on</h2>
            {socialIcons.map((icon, index) => (
              <a href="#/" key={index}>
                <img src={icon.src} alt={icon.alt} loading="lazy" />
              </a>
            ))}
          </div>
          <div className={Style.AppIcon}>
            {appIcons.map((icon, index) => (
              <a href="#/" key={index}>
                <img src={icon.src} alt={icon.alt} loading="lazy" />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className={Style.foot}>
        <div className={Style.wrapper1}>
          <h2>Copyright © 2025 Bipko.Info. All rights reserved</h2>
          <h3>
            <a href="#/">Privacy Policy </a> - Terms & Conditions
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Footer;
